export const DATA_TEST_IDS = {
  PAYROLL_SCREEN: "payroll-screen",
  PAYROLL_SCREEN_CONFIGURATION: "payroll-screen-configuration",
  PAYROLL_SCREEN_BODY: "payroll-screen-body",
  PAYROLL_CREATE_BUTTON: "payroll-create-button",
  PAYROLL_CREATE_DRAWER_CANCEL: "payroll-create-drawer-cancel",
  PAYROLL_CREATE_DRAWER_SAVE: "payroll-create-drawer-save",
};
